import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

import { ourServicesData } from '../../assets/Json/staticData';
// import Slider from 'react-slick';
import ServicesCard from '../../components/ServicesCard';
import Seo from '../../components/Seo/Seo';

export default function OurServices() {
  const tabList = [
    {
      name: "End to End Design Service",
      value: "design",
      label: "End to End Design Service"
    },
    {
      name: "Interior Execution",
      value: "execution",
      label: "Interior Execution"
    },
    {
      name: "Turnkey Consultant",
      value: "consultant",
      label: "Turnkey Consultant"
    },
  ]

  const [value, setValue] = React.useState('design');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };



  return (
    <div className='bg-light'>
    <div className='container mt-4'>
      <Seo
        title="Our Services | Architectural, Interior & Structural Design in Tirunelveli"
        description="Explore JB Architects & Engineers' services in Tirunelveli: custom house design, commercial architecture, 3D interior walkthroughs, 360 interior design, structural drawings and building plan approval services."
        keywords={[
          "interior designers in tirunelveli",
          "residential architects in tirunelveli",
          "commercial building designers in tirunelveli",
          "3d elevation designers in tirunelveli",
          "structural design consultants in tirunelveli",
          "custom house design services",
          "3d interior design walkthroughs",
          "360 interior design services",
          "structural coordination and drawings",
          "building plan approval drawings",
          "construction drawing services",
        ]}
        path="/services"
      />
      <Box sx={{ width: '100%' }}>

        <Typography variant="h4" padding="10px" color='orange'>
          Our Services
        </Typography>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          aria-label="wrapped label tabs example"
        >
          {tabList.map((tab, idx) => {
            return (
              <Tab value={tab.value} label={tab.label} sx={{
                whiteSpace: 'normal', // Allow text wrapping
                textAlign: 'center', // Center-align text
                fontSize: { xs: '10px', sm: '14px', md: '16px' },
              }} />
            )
          })}



        </Tabs>
        <div className='mt-4'>
          {(value === 'design') &&
            ourServicesData.design.map((service, idx) => {
              return (
                <ServicesCard service={service} />
              )
            })

          }
          {(value === 'execution') &&
            ourServicesData.execution.map((service, idx) => {
              return (
                <ServicesCard service={service} />
              )
            })

          }
          {(value === 'consultant') &&
            ourServicesData.consultant.map((service, idx) => {
              return (
                <ServicesCard service={service} />
              )
            })

          }
        </div>
      </Box>
    </div>
    </div>

  );
}